export enum CheckinAvailabilityStatus {
    Schedule = 0,
    Open,
    Closed,
    Blocked,
    Unavailable
}